module.exports = __webpack_public_path__ + "img/3.b63f25fe.svg";